import React, { memo, useContext, useEffect } from 'react';
import InputSwitch from '@Components/Common/InputSwitch';
import { StyleContext } from '@Models/style';
import useSystemColorScheme from '@Hooks/useSystemColorScheme';

function StyleToggle(): React.ReactElement {
  /* States */
  const context = useContext(StyleContext);
  const systemTheme = useSystemColorScheme();

  /* Functions */
  const handleToggleStyle = (): void => {
    context?.setStyleName(context?.styleName === 'light' ? 'dark' : 'light');
  };

  /* Hooks */
  useEffect(() => {
    context?.setStyleName(systemTheme);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [systemTheme]);

  /* Main */
  return (
    <InputSwitch
      checked={context?.styleName === 'dark'}
      onChange={handleToggleStyle}
    >
      toggle dark theme
    </InputSwitch>
  );
}

export default memo(StyleToggle);
